import { getToken } from '@/utils/token'
import { AxiosInstance } from 'axios'

const AUTH_HEADER_NAME = 'token'

export const attachCommonInterceptors = (client: AxiosInstance) => {
  client.interceptors.request.use(config => {
    const token = getToken()
    if (token) {
      config.headers.common[AUTH_HEADER_NAME] = token
    }
    config.params = { ...config.params, o: 'web' }
    return config
  })
}
